import apiPaywall from './api'

const getFlow = (body) => {
        return apiPaywall.post(`/Paywall/GetFlow`, body)
};

module.exports = {
    getFlow
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/services/flow.js